import { useContext, useMemo } from 'react'
import CountryLangCtx from 'app/contexts/countryLang/CountryLangCtx'
import countries from 'app/constants/countries'
import languages from 'app/constants/languages'

const usePrivacyPolicyLink = () => {
  const { country, language } = useContext(CountryLangCtx)

  return useMemo(() => {
    const isUS = country === countries.us
    const canadianPrivacy = `https://privacy.sherwin-williams.com/${language === languages.fr ? 'ca/fr/' : ''}privacy-policy`
    const usPrivacy = 'https://privacy.sherwin-williams.com/privacy-policy'
    return isUS ? usPrivacy : canadianPrivacy
  }, [country, language])
}

export default usePrivacyPolicyLink
